import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import AdminService from "../../services/AdminService";
import { switchSchool } from "../../actions/SchoolActions";
import { fetchCurrentSsoUser } from "../../actions/AuthActions";
import { Typeahead } from "react-bootstrap-typeahead";

function SchoolSwitchInput ({school, auth, fetchCurrentSsoUser, switchSchool}) {
  const [disableSwitching,setDisableSwitching] = useState(false);
  const [schools,setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState({name:school.schoolName, value: school.schoolCode});

  const typeheadRef = React.createRef();

  useEffect(()=> {
    if (!auth.ssoUser && !auth.user) {
      // attempt to load the current sso user based on the current token
      // This logic should be fired when a user logs in through the dashboard
      fetchCurrentSsoUser();
    }else{
      async function getAvailableSchools(){
        const availableSchoolResponse = await AdminService.getAvailableSchools(
          auth.ssoUser
        );
        if (!availableSchoolResponse || availableSchoolResponse.length < 2) {
          setDisableSwitching(true);
        } else {
          setSchools(availableSchoolResponse);
        }
      };

      getAvailableSchools();
    }
  },[auth.ssoUser, auth.user, fetchCurrentSsoUser])


  useEffect(()=> {
    setSelectedSchool({name: school.schoolName, value: school.schoolCode})
  },[school])

  const schoolSwitch = async (schoolCode) => {
    if (schoolCode) {
      // Repopulate the relevant information in redux (school and permissions)
      switchSchool(schoolCode, null, null);
    }
    return null;
  };

  const handleChange = (option) => {
    if(option?.length > 0){
      schoolSwitch(option[0].value); 
      setSelectedSchool({name: option[0].name, value: option[0].value});
    }
  }

  if (
    disableSwitching
  ) {
    return (<strong>{school.schoolName}</strong>);
  } else {
    return (
        //if there are multiple schools, render a different input type
      < div className = "inline" id = "schoolSelectInput" >
          <br/>
          <Typeahead
            id={1}
            onBlur={() => setSelectedSchool({name:school.schoolName, value:school.schoolCode})}
            onFocus={()=>typeheadRef.current.clear()}
            labelKey="name"
            multiple={false}
            ref={typeheadRef}
            options={schools.map(school => {
              return {name: school.name, value: school.code};
            })}
            onChange={option => handleChange(option)}
            placeholder={"School"}
            selected={[selectedSchool]}
          />
        </div >
      );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    school: state.school
  };
};

export default connect(mapStateToProps, {
  switchSchool,
  fetchCurrentSsoUser
})(SchoolSwitchInput);
